// @flow
import React, {type Node, useCallback} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import AppLink from 'components/ui/AppLink'
import ItemsSection from 'components/SideBar/ui/ItemsSection'
import {button} from './index.scss'
import type {
  OrganizationSection_organization as Organization,
} from './__generated__/OrganizationSection_organization.graphql'

type Props = $ReadOnly<{
  organization: Organization,
}>

const title = I18n.t('side_nav.organization.title')

function OrganizationSection({organization}: Props): Node {
  const anchorRolePath = organization.anchorRole.chartPath

  const renderTitle = useCallback(() => (
    <AppLink
      className={button}
      href={anchorRolePath}
    >
      {title}
    </AppLink>
  ), [anchorRolePath])

  return (
    <ItemsSection
      renderTitle={renderTitle}
      sectionName="organization-sections"
      title={title}
    />
  )
}

export default (createFragmentContainer(OrganizationSection, {
  organization: graphql`
    fragment OrganizationSection_organization on Organization {
      anchorRole {
        chartPath
      }
    }
  `,
}): RelayFragmentContainer<typeof(OrganizationSection)>)
